import api from '@pray/shared/utils/api';

export type SystemCheckWorkflowItem = {
  content_public_id: string;
  content_title: string;
  artist_name: string;
  artist_public_id: string;
  workflow_ai_status: string | null;
  workflow_ai_email_status: string | null;
  workflow_ai_announcement_status: string | null;
  transcript_status: string | null;
  created_at: string;
  updated_at: string;
};

export type SystemCheckWorkflowResponse = {
  data: SystemCheckWorkflowItem[];
  pagination: {
    next_cursor: string | null;
    has_more: boolean;
    total_count: number;
  };
};

export type GetSystemCheckWorkflowParams = {
  cursor?: string | null;
  limit?: number;
  artistId?: string;
};

export async function getSystemCheckWorkflow({
  cursor = null,
  limit = 50,
  artistId,
}: GetSystemCheckWorkflowParams = {}): Promise<SystemCheckWorkflowResponse> {
  const params: Record<string, string | number> = { limit };

  if (cursor) params.cursor = cursor;
  if (artistId) params.artist_id = artistId;

  const url = '/web/studio/system-check/workflow';
  const response = await api.executeGetRequest<{ data: SystemCheckWorkflowResponse }>(url, params);

  return response.data.data;
}
